<template>
  <div class="down_load_box" v-if="server_date_json.show">
    <div class="down_load_ct">
      <div class="down_load_mark"></div>
      <div class="down_load_option">
        <!-- 头部渐变 -->
        <div class="linear">
          <div class="linear_lt">
            <!-- <img style="display: none;"
              :src="isloginType == 'phone' ? require('@/assets/image/phone_icon.png') : require('@/assets/image/pass_icon.png')"
              alt=""> -->
          </div>
          <div class="code_title">全部开服</div>
          <div class="linear_rt">
            <img @click="handelClosePop" src="@/assets/image/reserve_cancel_ic.png" alt="">
          </div>
        </div>
        <!-- 全部开服 -->
        <div class="option_ct">
          <div class="option_ct_header">
            <div class="ser_tip"> 开服提醒 <span>（勾选下方开服，开服即可收到短信提醒）</span> </div>
            <div class="ser_swich">
              <!-- <el-switch v-model="switchTip" active-color="#ff4949" inactive-color="#cccccc">
              </el-switch> -->
            </div>
          </div>
          <div v-if="serversList.length > 0" class="option_main">
            <div class="item_li" v-for="(item, index) in serversList" :key="'item_li' + index"
              @click="serverSubscribe(item, index)">
              <div class="li_lt">
                <h4> {{ item.start_time | formatTime7 }}</h4>
                <p>{{ item.server_name }}</p>
              </div>
              <div class="li_rt">
                <i :class="item.notice == 1 ? 'select' : ''"></i>
              </div>
            </div>
          </div>
          <div v-else class="empty">
            <img src="@/assets/image/default_rebate.png" alt="">
            <p>当前游戏暂无新服内容</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postData } from '@/api/api.js'
import { mapState } from 'vuex'
import Bus from "@/util/Bus";

export default {
  name: 'ServerDate',
  props: {
    server_date_json: {
      type: Object,
      required: true,
      default: () => ({}) // ✅ 默认值用函数返回对象
    }
  },
  data() {
    return {
      switchTip: false,
      servers: [],//有游戏的开服数据
      serversList: []// 无date时间的开服数据
    }
  },
  created() {
  },
  computed: {
    ...mapState(['uid', 'requestParams', 'platform']),
  },
  watch: {
    // 监听 server_date_show.id 的变化
    'server_date_json.id': function (newVal, oldVal) {
      // 当 server_date_show.id 改变时触发
      this.moreServers()
    }
  },
  methods: {
    // 关登录弹窗
    handelClosePop() {
      Bus.$emit("serverDateShow", { ...this.server_date_json, show: false });
    },
    handelSerTips(index, notice) {
      this.$set(this.serversList[index], 'notice', notice);
      console.log(this.serversList[index])
    },
    async moreServers() {
      const params = {
        gid: this.server_date_json.id,
        platform: this.platform,
        uid: this.uid,
        subchannelnum: this.requestParams.subchannelnum,//广告商分包id
      };
      try {
        const res = await postData(
          "/box/more-servers",
          params
        );
        if (res?.code === 0) {
          this.servers = res.data.filter(item => item.servers.length !== 0);
          // console.log('moreServers', this.servers);
          this.serversList = [];
          res.data.forEach(item => {
            if (item.servers.length > 0) {
              this.serversList.push(...item.servers)
            }
          })
        } else {
          this.$message.error({
            message: res.msg,
            center: true, // 设置消息居中
            duration: 2000 // 消息持续时间
          }); // 显示成功消息
        }
      } catch (err) { }
    },
    // 订阅通知
    async serverSubscribe(item, index) {
      // 打开登录弹窗
      const isLogin = localStorage.getItem('loginMes') === 'true';
      if (!isLogin) return Bus.$emit("loginShow", true);
      console.log(item, item.notice, 'item')
      const params = {
        gid: this.server_date_json.id,
        uid: this.uid,
        time: item.start_time,
        sid: item.server_id ? item.server_id : 0,
        server_name: item.server_name,
        status: item.notice == 1 ? 1 : 0,
        subchannelnum: this.requestParams.subchannelnum,//广告商分包id
      };
      try {
        const res = await postData(
          "/box/server-subscribe",
          params
        );
        if (res?.code === 0) {
          if (item.notice === 0) {
            this.$message.success({
              message: '设置成功，开服前15分钟将通过手机信息通知您',
              center: true, // 设置消息居中
              duration: 2000 // 消息持续时间
            }); // 显示成功消息
            this.handelSerTips(index, 1)
          } else {
            this.$message.success({
              message: '已取消提醒',
              center: true, // 设置消息居中
              duration: 2000 // 消息持续时间
            }); // 显示成功消息
            this.handelSerTips(index, 0)
          }
          // this.serversList.forEach(item => {
          //   if (item.id == id) {
          //     item.notice = status == 1 ? 0 : 1
          //   }
          // })
          this.$forceUpdate()
        } else {
          this.$message.error({
            message: res.msg,
            center: true, // 设置消息居中
            duration: 2000 // 消息持续时间
          }); // 显示成功消息
        }
      } catch (err) { }
    },
  }
}
</script>

<style scoped lang="less">
.down_load_box {
  position: fixed;
  width: 100%;
  height: 100vh;
  z-index: 999;
}

.down_load_ct {
  position: relative;
  width: 100%;
  height: 100%;

  .down_load_mark {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
  }

  .down_load_option {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 580px;
    // height: 684px;
    border-radius: 20px;
    background-color: #ffffff;
    padding: 0 0 40px 0;
    z-index: 2;

    .linear {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      // height: 50px;
      padding: 25px 26px 10px 46px;
      box-sizing: border-box;
      border-radius: 20px 20px 0 0;
      background: linear-gradient(to bottom, #FFE8E9, #FFFFFF);

      .linear_lt {
        cursor: pointer;
      }

      .code_title {
        font-size: 20px;
        font-weight: 700;
      }

      .linear_rt {
        width: 16px;
        height: 16px;
        // align-self: flex-start;
      }
    }

    .option_ct {
      // margin-top: 30px;
      padding: 10px 30px;
      box-sizing: border-box;

      .option_ct_header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        // height: 50px;
        padding: 10px 20px;
        box-sizing: border-box;
        border-radius: 8px;
        background-color: #f5f5f5;

        .ser_tip {
          h4 {
            font-size: 14px;
          }

          span {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.4);
          }
        }
      }

      .option_main {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 30px;
        max-height: 300px;
        overflow-y: auto;

        &::-webkit-scrollbar {
          display: none;
        }

        .item_li {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 47.5%;
          height: 100px;
          margin-bottom: 15px;
          border: 2px solid rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          padding: 0 20px;
          box-sizing: border-box;
          // margin-right: 18px;

          &:nth-of-type(3n) {
            margin-right: 0;
          }

          .li_lt {
            text-align: left;

            h4 {
              font-size: 18px;
            }

            p {
              margin-top: 5px;
              font-size: 12px;
              color: #999;
            }
          }

          .li_rt {
            i {
              display: inline-block;
              width: 15px;
              height: 15px;
              border-radius: 50%;
              border: 1px solid #D9D9D9;
            }

            .select {
              background-image: url('@/assets/image/bind_suc.png');
              background-size: cover;
              // border: none;
            }
          }

        }
      }

      .empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 50px;

        >img {
          width: 120px;
          height: 120px;
        }

        >p {
          margin-top: 10px;
          font-size: 14px;
          color: rgba(0, 0, 0, .4);
        }
      }
    }
  }

}
</style>
